<div class="gap-lg flex flex-col">
  <h3 class="text-base font-semibold">
    {{ 'attributes.tags' | translate }}
  </h3>

  <div class="gap-x-lg gap-y-xl flex flex-wrap">
    @for (tag of tags(); track $index) {
      <bx-tag
        class="text-nowrap"
        [label]="tag.label"
        [action]="tag.action"
        [closeAriaLabel]="'system.tag.aria.remove' | translate: { tag: tag.label }"
        (closeClick)="handleRemove(tag.label)"
      ></bx-tag>
    }
  </div>

  <form [formGroup]="tagForm">
    <bx-input icon="plus" size="sm" [type]="'default'" [destructive]="isError()" [hintText]="hintText()" (keydown.enter)="handleAddTag()">
      <input #bxInput id="tag" formControlName="tag" [placeholder]="'tags.add.placeholder' | translate" />
    </bx-input>
  </form>
</div>
